import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { ColorPicker } from './color-picker.component';
import { ColorSlider } from './color-slider.component';
import { ColorPalette } from './color-palette.component';
import { ColorInput } from './color-picker-input.component';
import { IconModule } from '../icon/icon.module';
import { OverlayModule } from '@angular/cdk/overlay';

@NgModule({
  declarations: [
    ColorPicker,
    ColorSlider,
    ColorPalette,
    ColorInput,
  ],
  exports: [
    ColorPicker,
    ColorSlider,
    ColorPalette,
    ColorInput,
  ],
  imports: [
    CommonModule,
    OverlayModule,
    FormsModule,
    IconModule,
  ],
  entryComponents: [
    ColorPicker,
  ],
})
class ColorPickerModule { }

export {
  ColorPickerModule,
  ColorPicker,
  ColorSlider,
  ColorPalette,
  ColorInput,
};
